import React, { Component } from 'react';
import { Button, Col, Form, Input, Modal, Row, Table } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import { queryFilePreview } from '@api/pub/attachment';

const FormItem = Form.Item;

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: this.props.dataSource,
      selectedRowKeys: [],
    };
  }

  componentDidMount() {
    const { selectedRowKeys } = this.props;
    this.setState({ selectedRowKeys });
  }

  componentWillReceiveProps(nextProps) {
    const { selectedRowKeys } = nextProps;
    this.setState({
      dataSource: nextProps.dataSource,
      selectedRowKeys,
    });
  }

  // 分页跳转
  handleChange = pagination => {
    this.props.onChange(pagination);
  };

  // 选中
  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.setState({
      selectedRowKeys,
      selectedRows,
    });
  };

  // 确认
  handleOk = () => {
    const { selectedRowKeys, selectedRows } = this.state;
    selectedRowKeys && selectedRows && this.props.onSelectChange(selectedRowKeys, selectedRows);
    this.props.handleCancel();
  };

  // 关闭
  handleCancel = () => {
    this.props.handleCancel();
  };

  // 资料文档搜索
  handleSearch = () => {
    this.props.form.validateFields((err, values) => {
      const condition = values.condition || '';
      this.props.handleSearch(condition);
    });
  };

  columns = () => {
    return [
      {
        title: '文件编号',
        dataIndex: 'no',
        key: 'no',
        render: (text, record) => {
          return (
            <div key={record.url}>
              <a
                onClick={() =>
                  queryFilePreview(record.files[0], `仅限${this.props.accountInfo.userName}查看`)
                }
              >
                {record.no}
              </a>
            </div>
          );
        },
      },
      {
        title: '文件名称',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '文件类型',
        dataIndex: 'type',
        key: 'type',
      },
      {
        title: '文件有效期',
        dataIndex: 'beginDate',
        key: 'beginDate',
        render: (text, record) => {
          let beginDate = '';
          beginDate = record.beginDate ? moment(record.beginDate).format('YYYY-MM-DD') : '';
          let endDate = '';
          endDate = record.endDate ? moment(record.endDate).format('YYYY-MM-DD') : '永久';
          return (
            <span>
              {beginDate}至{endDate}
            </span>
          );
        },
      },
      {
        title: '所属公司',
        dataIndex: 'company',
        key: 'company',
      },
      {
        title: '所属资料库',
        dataIndex: 'database',
        key: 'database',
      },
      {
        title: '管理员',
        dataIndex: 'manager',
        key: 'manager',
      },
      {
        title: '总量/库存',
        dataIndex: 'amount',
        key: 'amount',
        render: (text, record) => {
          return (
            <span>
              {record.amount}/{record.number || 0}
            </span>
          );
        },
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
      selectedRowKeys,
    } = this.state;
    const { isLoading } = this.props;
    const { getFieldDecorator } = this.props.form;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      type: 'radio',
    };
    return (
      <Modal
        title="资料列表"
        visible={this.props.visible}
        onCancel={this.handleCancel}
        onOk={this.handleOk}
        width="90%"
      >
        <Row>
          <Col span={4} style={{ paddingRight: '10px' }}>
            <FormItem>
              {getFieldDecorator('condition', {
                initialValue: this.props.condition,
              })(<Input />)}
            </FormItem>
          </Col>
          <Col span={3}>
            <FormItem>
              <Button type="primary" onClick={this.handleSearch}>
                搜索
              </Button>
            </FormItem>
          </Col>
        </Row>
        <Table
          tableLayout="inline"
          loading={isLoading}
          rowSelection={rowSelection}
          onChange={this.handleChange}
          columns={this.columns()}
          pagination={pagination}
          dataSource={list}
          rowKey="uuid"
        />
      </Modal>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Form.create()(Manage));



// WEBPACK FOOTER //
// ./src/components/administrative/material/borrow/ModalFileList.js